@if (avatar) {
  <div id="studentAvatarModalComponent" class="studentAvatarModalComponent">
    <div class="modal-header">
      <h3 class="modal-title h4 text-uppercase" id="studentAvatarModalTitle">Customize Your Avatar</h3>
    </div>
    <form id="studentAvatarForm" [formGroup]="form" (ngSubmit)="save()">
      <div class="modal-body">
        <div class="mb-3 w-100">
          <label for="avatarName">
            <strong>Pick a Name:</strong>
            <input id="avatarName" name="name" class="form-control" required maxlength="30" formControlName="name">
          </label>
        </div>
        <div class="mb-3 w-100">
          <label for="avatarColor">
            <strong class="d-block">Choose a Color:</strong>
            <zbp-color-picker name="color" id="avatarColor" [color]="avatar.color" [useNative]="false" formControlName="color"></zbp-color-picker>
          </label>
        </div>
      </div>
      <div class="modal-footer">
        <button id="saveAvatarButton" type="submit" class="btn btn-outline-tertiary text-uppercase btn-sm">Save</button>
        <button id="cancelAvatarSaveButton" class="btn btn-outline-tertiary text-uppercase btn-sm" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </div>
}
